module.exports = __webpack_public_path__ + "static/media/nurse_accredited2.8cb013df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurse_accredited2.png
// module id = 481
// module chunks = 0